import * as actionTypes from "../../Constants/actionTypes";
import { StatisticLabel } from "semantic-ui-react";

export const initialState = {
    loading: false,
    isLoading: false,
    error: null,
    allUsers: [],
    originalAllUsers: "",
    userProfileLook: {},
    insertstatus: "new",
    userData: {
        primarybilling_rate: 0,
        secondarybilling_rate: 0,
        Task_Locations: "",
        wrk_exp_begindate: "",
        account_disabled: "",
        belongsto_group: "",
        branch_id: 0,
        department: "",
        email_id: "",
        employee_id: "",
        expertise: "",
        firm_id: 0,
        first_name: "",
        generation_type: "",
        industry_group: "",
        IP_from: "",
        last_name: "",
        middle_name: "",
        niche_group: "",
        page_id: "",
        parttime_employee: "",
        phone_number: "",
        primary_role: "",
        secondary_role: "",
        title_level: "",
        user_id: 0,
        yearsofexp: "",
        rowsCount: 0,
        last_login: "",
    },
    activeInactiveDataobj: {},
    lookupData: {},
    selectedUsers: {
        selectedUsersIds: [],
        selectedUsersStatus: [],
    },
    updatedUsers: [],
    bulkUpdatedUsers: {},
    isExport: false,
    isEdited: false,
    // isRefresh: false,
    isClearFilters: false,
    isModalOpen: false,
    isSortSelectedUsers: false,
    staffReportDetails: [],
    firmLookUpDetails: {},
    firmGracePeriodData: {},
    IntegrationPhaseData: {},
    isLicenseExists: false,
    failedCount: 0
    //filterUserStatus: true
};

const userReducer = (state = initialState, action) => {
    //console.log("checking state and actions", state, action);
    switch (action.type) {
        case actionTypes.GET_ALL_USERS:
            return {
                ...state,
                allUsers: action.payload.mappedData,
                originalAllUsers: JSON.stringify(action.payload.mappedData),
                isModalOpen: action.payload.isModalOpen,
                isEdited: action.payload.isEdited,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                }
            };

        case actionTypes.GET_SELECTED_USERS:
            return {
                ...state,
                selectedUsers: action.payload
            };

        case actionTypes.CLEAR_SELECTED_USERS:
            return {
                ...state,
                allUsers: action.payload.allUsers,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                }
            };


        case actionTypes.DISCARD_CHANGES_YES:
            return {
                ...state,
                isEdited: false,
                //   // isModalOpen: action.payload.isModalOpen,
                isLoading: false,
                updatedUsers: [],
                allUsers: JSON.parse(state.originalAllUsers)

            };

        case actionTypes.GET_LOOKUP_DATA:
            return {
                ...state,
                lookupData: action.payload
            };
        case actionTypes.RESET_LOADING:
            return {
                ...state,
                isLoading: action.payload.isLoading
            };


        case actionTypes.BULK_UPDATE_USERS:
            return {
                ...state,
                //isLoading: action.payload.isLoading,
                // bulkUpdatedUsers: action.payload.bulkUpdatedUsers,
                allUsers: action.payload.allUsers,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                }
            };

        case actionTypes.ENABLE_DISABLE_USERS:
            return {
                ...state,
                activeInactiveDataobj: action.payload.activeInactiveDataobj,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                },
                allUsers: action.payload.allUsers
            };

        // case actionTypes.REFRESH_GRID_DATA:
        //   return {
        //     ...state,
        //     isRefresh: action.payload.isRefresh,
        //     filterUserStatus: action.payload.filterUserStatus,
        //     isEdited: action.payload.isEdited,

        //     // isClearFilters: action.payload.isClearFilters,
        //     selectedUsers: {
        //       ...state.selectedUsers,
        //       selectedUsersIds: [],
        //       selectedUsersStatus: []
        //     }
        //   };

        case actionTypes.CLEAR_ALL_FILTERS:
            return {
                ...state,
                isClearFilters: action.payload.isClearFilters,
                // filterUserStatus: action.payload.filterUserStatus,
                allUsers: action.payload.allUsers,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                }
            };

        // case actionTypes.SHOW_FILTER_ICON:
        //   return {
        //     ...state,
        //     showFilterIcon: action.payload.showFilterIcon,
        //   };

        case actionTypes.SHOW_MODAL_TO_DISCARD:
            if (action.payload.updatedUsers) {
                return {
                    ...state,
                    isModalOpen: action.payload.isModalOpen,
                    isEdited: action.payload.isEdited,
                    updatedUsers: action.payload.updatedUsers
                };
            }
            return {
                ...state,
                isModalOpen: action.payload.isModalOpen
            };

        case actionTypes.GET_USER_DETAILS:
            let _res = action.payload;
            if (_res.UserIndividualData) {
                let _newState = Object.assign({}, state);
                _newState.userData = _res.UserIndividualData;
                state = _newState;
            }
            return state;


        case actionTypes.GRID_UPDATE:


            let result = action.payload;
            let newState = Object.assign({}, state);
            if (result.allUsers && result.allUsers.length) {

                newState.allUsers = result.allUsers;
                newState.originalAllUsers = JSON.stringify(result.allUsers);
            }
            newState.isEdited = result.isEdited;
            newState.isLoading = result.isLoading;
            newState.updatedUsers = result.updatedUsers;
            state = newState;

            return state;



        // return {
        //   ...state,
        //   isEdited: action.payload.isEdited,
        //   // isModalOpen: action.payload.isModalOpen,
        //   isLoading: action.payload.isLoading,
        //   updatedUsers: action.payload.updatedUsers,
        //   allUsers: action.payload.allUsers

        // };

        case actionTypes.EXPORT_TO_EXCEL:
            return {
                ...state,
                isExport: action.payload.isExport
            };
        case actionTypes.ROWS_COUNT_AFTER_FILTER:
            return {
                ...state,
                rowsCount: action.payload.rowsCount
            };
        case actionTypes.SORT_SELECTED_USERS:
            return {
                ...state,
                isSortSelectedUsers: action.payload.isSortSelectedUsers,
                allUsers: action.payload.finalSortedUsers
            };

        case actionTypes.CLEAR_ALL_USERS:
            return {
                ...state,
                allUsers: []
            };
        case actionTypes.GET_STAFF_REPORT_DATA:
            return {
                ...state,                
                staffReportDetails: action.payload.staffReportData               
            };
        case actionTypes.GET_STAFF_LOOKUP_DATA:
            return {
                ...state,
                staffLookupData: action.payload.staffLookups
            };
        case actionTypes.GET_FIRM_LOOKUP_DATA:
            return {
                ...state,
                firmLookUpDetails: action.payload.firmLookups,                 
            };
        case actionTypes.UPDATE_GRACEPERIOD_DATA:
            return {
                ...state,
                staffIntegratedFlag: action.payload.gracePdCount,
            };
        case actionTypes.GET_FIRM_GRACEPERIOD_DATA:
            return {
                ...state,
                firmGracePeriodData: action.payload.gracePeriodData,
            };
        case actionTypes.GET_STAFF_INTPH_DATA:
            return {
                ...state,
                IntegrationPhaseData: action.payload.IntegrationPhase,
            };
        case actionTypes.GET_LICENSE_DATA:
            return {
                ...state,
                isLicenseExists: action.payload.LicenseData,
            };

        default:
            return state;
    }    
};

export default userReducer;
